import { render, staticRenderFns } from "./DialogCreateNewActiveChat.vue?vue&type=template&id=5c1e2267&scoped=true&"
import script from "./DialogCreateNewActiveChat.vue?vue&type=script&lang=ts&"
export * from "./DialogCreateNewActiveChat.vue?vue&type=script&lang=ts&"
import style0 from "./DialogCreateNewActiveChat.vue?vue&type=style&index=0&id=5c1e2267&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c1e2267",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VWindow } from 'vuetify/lib/components/VWindow';
import { VWindowItem } from 'vuetify/lib/components/VWindow';
installComponents(component, {VBtn,VWindow,VWindowItem})
